import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { eventSet } from '../../store/eventSlice';
import { exhibitorSet }  from '../../store/exhibitorSlice';
import { useParams } from "react-router-dom";
import useApiGet from '../../hooks/useApiGet';
import Loader from '../common/Loader';
import Error from '../common/Error';
import '../exhibitor/Exhibitor.css';
import ExhibitorLeft from '../exhibitor/ExhibitorLeft';
import ActivityMain from './ActivityMain';

const Activity = () => {
	const { i18n } = useTranslation();
    const { id, lang } = useParams();
	const dispatch = useDispatch();
	const method = '/activities/' + id;
	const [ data, error, isLoading ] = useApiGet({ method });

	useEffect(() => {
		if(!lang) return; // если язык не установили по УРЛ, то не меняем его
		if(lang === 'en') {
			i18n.changeLanguage('en')
		} else {
			i18n.changeLanguage('ru')
		}
	}, [ lang, i18n ]);

	useEffect(() => {
		if(!data) return;
        dispatch(exhibitorSet(data.activity.exhibitor));
		dispatch(eventSet(data.activity.event));
	}, [ data, dispatch ]);

	return (
		<div className='Content-flex'>
		{isLoading ? <Loader/> :
		<React.Fragment>
		{error ? <Error error={error}/> :
			<React.Fragment>
			{data &&
				<React.Fragment>
					<div className='Content-left'>
						<ExhibitorLeft exhibitor={data.activity.exhibitor}/>
					</div>
					<div className='Content-main'>
						<ActivityMain activity={data.activity}/>
					</div>
				</React.Fragment>}
			</React.Fragment>}
		</React.Fragment>}
		</div>
	);
};

export default Activity;
